import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Target, Activity, Eye } from 'lucide-react';
export function SolutionSection() {
  const triadPoints = [{
    icon: <Target className="w-8 h-8 text-accent" data-id="element-220" />,
    title: 'Pies',
    desc: 'La parte más honesta del cuerpo, revelan intención de fuga o interés real.'
  }, {
    icon: <Activity className="w-8 h-8 text-accent" data-id="element-221" />,
    title: 'Hombros',
    desc: 'Indicadores de tensión oculta y confianza genuina vs fingida.'
  }, {
    icon: <Eye className="w-8 h-8 text-accent" data-id="element-222" />,
    title: 'Pupilas',
    desc: 'Ventanas directas al sistema nervioso autónomo, imposibles de controlar.'
  }];
  return <section className="py-24 bg-background relative overflow-hidden" data-id="element-223">
      {/* Glow Effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/10 rounded-full blur-[100px] pointer-events-none" data-id="element-224"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-225">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-226">
          <FadeIn data-id="element-227">
            <h2 className="text-sm font-bold tracking-widest text-accent uppercase mb-4" data-id="element-228">
              El Descubrimiento
            </h2>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-229">
            <h3 className="text-4xl sm:text-5xl font-black text-white mb-8" data-id="element-230">
              El Método de la <br data-id="element-231" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-accent-light" data-id="element-232">
                "Tríada de la Verdad"
              </span>
            </h3>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-233">
            <p className="text-xl text-slate-300 leading-relaxed" data-id="element-234">
              He desarrollado un sistema de observación de tres puntos que
              hackea el sistema nervioso autónomo del otro. Son reacciones
              involuntarias que el cerebro humano no puede detener, por mucho
              que intente disimular.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-235">
          {triadPoints.map((point, index) => <FadeIn key={index} delay={0.3 + index * 0.1} direction="up" data-id="element-236">
              <div className="bg-surface border border-white/10 rounded-2xl p-8 text-center hover:border-accent/50 transition-all duration-300 group h-full" data-id="element-237">
                <div className="w-16 h-16 mx-auto bg-background rounded-full flex items-center justify-center mb-6 border border-white/5 group-hover:scale-110 transition-transform duration-300 shadow-[0_0_20px_rgba(212,168,83,0.1)] group-hover:shadow-[0_0_30px_rgba(212,168,83,0.3)]" data-id="element-238">
                  {point.icon}
                </div>
                <h4 className="text-2xl font-bold text-white mb-4" data-id="element-239">
                  {point.title}
                </h4>
                <p className="text-slate-400 text-lg" data-id="element-240">{point.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}